import {Counter, CounterConfig} from './types';
import {RealCounter} from './real-counter';
import {FakeCounter} from './fake-counter';

export class ProxyCounter implements Counter {
    private static realCounters: Record<string, RealCounter> = {};
    private static fakeCounters: Record<string, FakeCounter> = {
        main: new FakeCounter('main'),
    };

    static createCounters(configs: CounterConfig[]) {
        configs.forEach(({id, name}) => {
            ProxyCounter.realCounters[name] = new RealCounter(id);
        });
    }

    name: string;

    constructor(name: string) {
        this.name = name;

        ProxyCounter.fakeCounters[name] = new FakeCounter(name);
    }

    hit(...args: unknown[]) {
        this.getCounter()?.hit(...args);
    }

    params(...args: unknown[]) {
        this.getCounter()?.params(...args);
    }

    userParams(...args: unknown[]) {
        this.getCounter()?.userParams(...args);
    }

    reachGoal(...args: unknown[]) {
        this.getCounter()?.reachGoal(...args);
    }

    reachGoals(...args: unknown[]) {
        this.getCounter()?.reachGoals(...args);
    }

    getCounter() {
        if (ProxyCounter.realCounters[this.name]) {
            return ProxyCounter.realCounters[this.name];
        }
        return ProxyCounter.fakeCounters[this.name] || ProxyCounter.fakeCounters.main;
    }
}
